import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Link, TextField } from '@printdeal/ui-library';
import { OrderQueryMutationKey, usePatchOrderMutation } from '@printdeal/checkout-frontend';
import { SanitizedOrder } from '../../../../../types/order/Order';
import OrderDetailContext from '../../contexts/OrderDetailContext';

interface OrderPoNumberProps {
  order: SanitizedOrder;
}

const OrderPoNumber = ({
  order,
}: OrderPoNumberProps) => {
  const patchOrderMutation = usePatchOrderMutation({ context: OrderQueryMutationKey.orderSetPoNumber });
  const { reFetchOrder } = useContext(OrderDetailContext);
  const poNumberRef = useRef<HTMLInputElement>(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

  if (!reFetchOrder) {
    return null;
  }

  useEffect(() => {
    if (patchOrderMutation.isSuccess) {
      setIsFormVisible(false);
      reFetchOrder({});
    }
  }, [patchOrderMutation.isSuccess]);

  const handleOnClick = () => {
    patchOrderMutation.mutate({ orderId: order.id, action: { name: 'setPurchaseOrderNumber', value: poNumberRef.current?.value.trim() ?? '' } });
  };

  return (
    <div className="pd-flex pd-gap-4">
      <div className="pd-w-48">
        <div className="pd-font-bold">
          <FormattedMessage
            id="account.order.poNumber"
            defaultMessage="Po Number"
          />
        </div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          variant="secondary"
          onClick={() => setIsFormVisible(true)}
          as="button"
          className="pd-text-left pd-text-xs"
          data-cy="account.order.change.poNumber"
          iconBefore="edit"
        >
          <FormattedMessage id="account.order.change.poNumber" defaultMessage="Change Po Number" />
        </Link>
      </div>
      <div className="pd-grow">
        {isFormVisible ? (
          <div className="pd-flex pd-gap-3">
            <TextField
              type="text"
              name="poNumber"
              id="poNumber"
              defaultValue={order.custom?.fields.PONumber}
              maxLength={120}
              autoFocus
              className="pd-inline-block"
              disabled={patchOrderMutation.isPending}
              ref={poNumberRef}
            />
            <Button
              variant="secondary"
              size="md"
              disabled={patchOrderMutation.isPending}
              isLoading={patchOrderMutation.isPending}
              onClick={handleOnClick}
              data-cy="account.order.change.poNumber.button"
            >
              <FormattedMessage
                id="account.order.change.value"
                defaultMessage="Change order value"
              />
            </Button>
          </div>
        ) : (
          <div data-cy="account.order.poNumber.changed">
            {order.custom?.fields.PONumber || (
            <span className="pd-text-dim-500">
              <FormattedMessage id="account.order.ponumber.no.value" defaultMessage="No PO number value" />
            </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderPoNumber;
